/**
 * Modello puro delle guide in-app del sistema ticket (Task 20).
 *
 * Qui non entra JSX: solo la forma dei dati che `GuidePage.tsx` rende e
 * l'elenco chiuso delle immagini ammesse. I file .webp arrivano dopo, quindi
 * un test non puo verificare che esistano su disco: verifica invece che ogni
 * nome citato dai contenuti stia in questa whitelist, cosi un refuso si vede
 * subito e non diventa un'immagine muta in pagina.
 */

export interface GuideParagraph {
  type: 'p';
  text: string;
}

export interface GuideList {
  type: 'ul' | 'ol';
  items: string[];
}

/** Riquadro "Da sapere" (verde). */
export interface GuideTip {
  type: 'tip';
  title?: string;
  text: string;
}

/** Riquadro "Attenzione" (ambra). */
export interface GuideWarn {
  type: 'warn';
  title?: string;
  text: string;
}

export interface GuideImage {
  type: 'img';
  /** Nome del file dentro `public/guide/ticket/`, senza percorso. */
  src: string;
  /** Testo alternativo: resta a schermo anche quando il file non c'e. */
  alt: string;
  caption?: string;
}

export type GuideBlock = GuideParagraph | GuideList | GuideTip | GuideWarn | GuideImage;

export interface GuideSection {
  /** Ancora della sezione: finisce in `#id` e nel link del riepilogo. */
  id: string;
  title: string;
  blocks: GuideBlock[];
}

export interface GuideContent {
  title: string;
  intro: string[];
  sections: GuideSection[];
}

/** Cartella pubblica degli screenshot delle guide. */
export const GUIDE_IMAGE_BASE = '/guide/ticket/';

/**
 * Nomi ammessi degli screenshot (brief Task 20). I primi quindici sono del
 * Centro Ticket admin, gli ultimi tre dell'area rappresentante;
 * `14-associato-dettaglio.webp` e condiviso dalle due guide.
 */
export const GUIDE_IMAGE_WHITELIST: readonly string[] = [
  '01-coda.webp',
  '02-viste.webp',
  '03-scheda-ticket.webp',
  '04-menu-azioni.webp',
  '05-composer.webp',
  '06-invia-e.webp',
  '07-nota-interna.webp',
  '08-proprieta.webp',
  '09-componenti.webp',
  '10-trasferisci.webp',
  '11-posta-supporto.webp',
  '13-mittenti-ignorati.webp',
  '14-associato-dettaglio.webp',
  '15-profilo.webp',
  'r01-coda.webp',
  'r02-scheda.webp',
  'r03-dettagli.webp',
];

/** Tutti i nomi di immagine citati dalle sezioni, nell'ordine di comparsa. */
export const guideImageNames = (sections: GuideSection[]): string[] => {
  const out: string[] = [];
  for (const s of sections || []) {
    for (const b of s.blocks || []) {
      if (b.type === 'img') out.push(b.src);
    }
  }
  return out;
};

/** Id delle sezioni: alimenta il riepilogo e i controlli di coerenza. */
export const guideSectionIds = (sections: GuideSection[]): string[] =>
  (sections || []).map((s) => s.id);
